module.exports = __webpack_public_path__ + "img/title+@2x.9cc8ca1f.png";